export default class Toaster {
    constructor() {
        this.container = this.buildContainer();
        this.slots = [];
    }

    buildContainer = () => {
        const container = document.createElement('div');
        container.classList.add('jwc-toast-container');

        document.body.appendChild(container);

        return container;
    }

    toast = (settings) => {
        const toast = new Toast(settings, this);

        this.slots.push(toast);
        toast.show();

        this.container.appendChild(toast.element);

        return toast;
    }
}

class Toast {
    constructor(settings, toaster) {
        this.type = settings.type;
        this.title = settings.title;
        this.autoDismiss = settings.hasOwnProperty('autoDismiss') ? settings.autoDismiss : true;
        this.content = settings.content;
        this.id = Date.now() + toaster.slots.length;
        this.toaster = toaster;
        this.buildToast();
    }

    buildToast = () => {
        const toast = document.createElement('div');
        toast.classList.add('jwc-toast', `jwc-toast-${this.type}`);

        this.element = toast;

        this.buildIcon();
        this.buildBody();
        this.buildContent();
        this.buildCloser();
    }

    buildIcon = () => {
        const icon = document.createElement('div');
        icon.classList.add('jwc-toast-icon');
        icon.innerHTML = this.getTypeIcon(this.type);

        this.icon = icon;
        this.element.appendChild(this.icon);
    }

    buildBody = () => {
        const body = document.createElement('div');
        body.classList.add('jwc-toast-body');

        this.body = body;
        this.element.appendChild(this.body);
    }

    buildContent = () => {
        if (this.title) {
            const title = document.createElement('p');
            title.classList.add('jwc-toast-title');
            title.innerHTML = this.title;

            this.titleElement = title;
            this.body.appendChild(title);
        }

        if (this.content) {
            const content = document.createElement('p');
            content.classList.add('jwc-toast-content');
            content.innerHTML = this.content;
    
            this.contentElement = content;
            this.body.appendChild(content);
        }
    }

    buildCloser = () => {
        const closer = document.createElement('button');
        closer.classList.add('jwc-toast-closer');
        closer.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="jwc-toast-closer-icon">
                <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
            </svg>
        `;

        closer.addEventListener('click', this.clear)

        this.closerElement = closer;
        this.element.appendChild(closer);
    }

    show = () => {
        this.element.classList.add('transition-visible');
        this.isVisible = true;

        this.element.addEventListener('animationend', (e) => {          
            this.element.classList.remove('transition-visible');
            this.element.classList.add('is-visible');
        });

        if (this.autoDismiss) {
            setTimeout(() => {
                this.clear();
            }, 7000);
        }
    }
    
    clear = () => {
        this.element.classList.add('is-visible');
        this.element.classList.add('transition-clear');
        this.isVisible = false;

        this.element.addEventListener('animationend', (e) => {          
            this.element.parentElement.removeChild(this.element);
    
            this.toaster.slots = this.toaster.slots.filter(slot => {
                return slot.id !== this.id
            })
        })
    }

    getTypeIcon = (type) => {
        let icon = '';

        switch(type) {
            case 'success':
                icon = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>`;
                break;
            case 'warning':
                icon = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"/>
                    </svg>`;
                break;
            case 'favorite':
                icon = `
                    <svg width="21" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16" aria-hidden="true" focusable="false">
                        <g><path d="M14.64 5c.263 0 .504.15.618.387l1.381 2.842 3.087.455a.689.689 0 0 1 .382 1.169l-2.238 2.215.53 3.13a.691.691 0 0 1-1.003.721l-2.756-1.471-2.756 1.471a.69.69 0 0 1-1.003-.722l.528-3.13-2.238-2.214a.686.686 0 0 1 .382-1.169l3.085-.455 1.381-2.842A.688.688 0 0 1 14.64 5ZM2.25 10c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75a.748.748 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75h1.5Z"/><path d="m8.075 10.5 2.022 2H5.5a.999.999 0 0 1-.993-.883L4.5 11.5c0-.553.447-1 1-1h2.575ZM2.25 5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.748.748 0 0 1 0 7.25v-1.5C0 5.334.334 5 .75 5h1.5Zm10.585.5-.924 1.903-.664.097H5.5a.999.999 0 0 1-.993-.883L4.5 6.5c0-.553.447-1 1-1h7.335ZM2.25 0c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.748.748 0 0 1 0 2.25V.75C0 .334.334 0 .75 0h1.5ZM14.5.5a.999.999 0 1 1 0 2h-9a.999.999 0 1 1 0-2h9Z"/></g>
                    </svg>`;
                break;
        }

        return icon;
    }
}